function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EA6661",
  d: "M342.089 40.502c24.237 4.964 47.845 9.502 70.704 13.897 33.002 6.345 64.442 12.39 93.957 18.98 49.949 11.151 94.314 23.851 131.271 42.173 36.95 18.317 66.479 42.247 86.776 75.853 20.299 33.609 31.392 76.941 31.392 134.107 0 228.646-185.354 414-414 414-114.175 0-199.592-84.93-256.493-198.628C28.803 427.202.5 284.905.5 170.512c0-57.204 7.37-96.744 21.868-123.186C36.845 20.924 58.452 7.54 87.078 2.686c28.664-4.86 64.354-1.163 106.941 6.64 24.792 4.54 51.884 10.466 81.262 16.89 21.093 4.614 43.364 9.484 66.808 14.286z"
});

function SvgRightCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 613,
    height: 741,
    fill: "none",
    viewBox: "0 0 613 741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCircle);
export default __webpack_public_path__ + "static/media/right-circle.55a1fa63.svg";
export { ForwardRef as ReactComponent };